import fr from 'facet-rest';
import BaseOverride from '../../../BaseOverride';

export const wizardHiddenFields = ['moduleName', 'pretitle', 'title', 'subtitle', 'primaryText', 'secondaryText', 'additionalDetailTitle', 'additionalDetailItems', 'attachmentButtonText'];
export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(wizardHiddenFields, {
    hidden: true,
  })
  .done();
